import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'awair-welcome',
  template: `
    <div class="welcome-container">
      <svg width="237px" height="152px" viewBox="0 0 237 152" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="63.6363636%" gradientTransform="translate(0.500000,0.500000),scale(0.065217,1.000000),rotate(-90.000000),scale(1.000000,7.463231),translate(-0.500000,-0.500000)" id="radialGradient-1">
            <stop stop-color="#000000" stop-opacity="0.5" offset="0%"></stop>
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="100%"></stop>
          </radialGradient>
          <linearGradient x1="50%" y1="-52.7238282%" x2="50%" y2="50%" id="linearGradient-2">
            <stop stop-color="#000000" offset="0%"></stop>
            <stop stop-color="#000000" stop-opacity="0" offset="100%"></stop>
          </linearGradient>
          <path d="M145.110074,124 L143.725517,133.476923 C143.725517,133.476923 143.725517,135.169231 142.34096,136.184615 C140.956403,137.2 134.033617,142.953846 134.033617,142.953846 L134,145.221102 L134.033617,146 L196.966619,146 L196.966619,144.959954 C196.966619,144.959954 197.279001,144.03206 195.99255,142.953846 C193.569575,140.923077 187.685207,135.169231 187.685207,135.169231 C187.685207,135.169231 186.646789,132.8 186.30065,131.446154 C185.95451,130.092308 185.658758,124 185.658758,124 L145.110074,124 Z" id="path-3"></path>
          <rect id="path-4" x="72" y="0" width="185" height="124" rx="4"></rect>
          <rect id="path-5" x="223" y="23" width="25" height="9"></rect>
          <rect id="path-6" x="94" y="21" width="26" height="29"></rect>
          <rect id="path-7" x="95" y="63" width="107" height="33"></rect>
          <filter x="-1.4%" y="-1.5%" width="101.9%" height="106.1%" filterUnits="objectBoundingBox" id="filter-8">
            <feOffset dx="-1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix values="0 0 0 0 0.945098039   0 0 0 0 0.952941176   0 0 0 0 0.956862745  0 0 0 1 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
          </filter>
          <rect id="path-9" x="122" y="21" width="8" height="4"></rect>
          <rect id="path-10" x="94" y="16" width="15" height="2"></rect>
          <rect id="path-11" x="224" y="16" width="9" height="2"></rect>
          <rect id="path-12" x="224" y="21" width="24" height="14"></rect>
          <rect id="path-13" x="224" y="36" width="24" height="14"></rect>
          <rect id="path-14" x="224" y="86" width="9" height="2"></rect>
          <rect id="path-15" x="224" y="91" width="24" height="13"></rect>
          <rect id="path-16" x="224" y="51" width="24" height="14"></rect>
          <rect id="path-17" x="224" y="66" width="24" height="14"></rect>
          <rect id="path-18" x="94" y="58" width="9" height="2"></rect>
          <rect id="path-19" x="132" y="21" width="15" height="4"></rect>
          <rect id="path-20" x="148" y="21" width="11" height="4"></rect>
          <rect id="path-21" x="122" y="27" width="26" height="7"></rect>
          <rect id="path-22" x="122" y="35" width="26" height="7"></rect>
          <rect id="path-23" x="122" y="43" width="26" height="7"></rect>
          <rect id="path-24" x="149" y="27" width="26" height="7"></rect>
          <rect id="path-25" x="149" y="35" width="26" height="7"></rect>
          <rect id="path-26" x="149" y="43" width="26" height="7"></rect>
          <rect id="path-27" x="176" y="27" width="26" height="7"></rect>
          <rect id="path-28" x="176" y="35" width="26" height="7"></rect>
          <circle id="path-29" cx="692" cy="273" r="28"></circle>
          <filter x="-10.7%" y="-7.1%" width="117.9%" height="117.9%" filterUnits="objectBoundingBox" id="filter-30">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
            <feOffset dx="-1" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
            <feColorMatrix values="0 0 0 0 0.752789029   0 0 0 0 0.78163358   0 0 0 0 0.805670706  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
          </filter>
        </defs>
        <g id="Login+invitation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="begin-the-dashboard" transform="translate(-485.000000, -236.000000)">
            <g id="Mac" transform="translate(356.000000, 188.000000)">
              <g id="Group" transform="translate(78.000000, 48.000000)">
                <ellipse id="Oval-2" fill="url(#radialGradient-1)" opacity="0.300000012" cx="166" cy="144.5" rx="115" ry="7.5"></ellipse>
                <g id="Path-13">
                  <use fill="#E8EDF1" xlink:href="#path-3"></use>
                  <use fill-opacity="0.200000018" fill="url(#linearGradient-2)" xlink:href="#path-3"></use>
                </g>
                <rect id="Rectangle-10" fill="#CDD3D8" x="134" y="145" width="63" height="1"></rect>
                <g id="Rectangle-7">
                  <use fill="#E8EDF1" fill-rule="evenodd" xlink:href="#path-4"></use>
                  <rect stroke="#D4DDE3" stroke-width="1" x="72.5" y="0.5" width="184" height="123" rx="4"></rect>
                </g>
                <g id="Rectangle-15">
                  <use fill="#D8D8D8" fill-rule="evenodd" xlink:href="#path-5"></use>
                  <rect stroke="#979797" stroke-width="1" x="223.5" y="23.5" width="24" height="8"></rect>
                </g>
                <rect id="Rectangle-8" fill="#F8F9FA" x="78" y="6" width="173" height="98"></rect>
                <rect id="Rectangle-5" fill="#CDD3D8" x="220" y="6" width="32" height="98"></rect>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-6"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="94.5" y="21.5" width="25" height="28"></rect>
                </g>
                <circle id="Oval-4" fill="#D9EFE4" cx="102" cy="29" r="3"></circle>
                <g id="Rectangle-14">
                  <use fill="black" fill-opacity="1" filter="url(#filter-8)" xlink:href="#path-7"></use>
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-7"></use>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-9"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="122.5" y="21.5" width="7" height="3"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-10"></use>
                  <rect stroke="#DEE2E5" stroke-width="1" x="94.5" y="16.5" width="14" height="1"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-11"></use>
                  <rect stroke="#DEE2E5" stroke-width="1" x="224.5" y="16.5" width="8" height="1"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill-opacity="0.03" fill="#343A3E" fill-rule="evenodd" xlink:href="#path-12"></use>
                  <rect stroke-opacity="0.711050725" stroke="#DEE2E5" stroke-width="1" x="224.5" y="21.5" width="23" height="13"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill-opacity="0.03" fill="#343A3E" fill-rule="evenodd" xlink:href="#path-13"></use>
                  <rect stroke-opacity="0.711050725" stroke="#DEE2E5" stroke-width="1" x="224.5" y="36.5" width="23" height="13"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-14"></use>
                  <rect stroke="#DEE2E5" stroke-width="1" x="224.5" y="86.5" width="8" height="1"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill-opacity="0.03" fill="#343A3E" fill-rule="evenodd" xlink:href="#path-15"></use>
                  <rect stroke-opacity="0.711050725" stroke="#DEE2E5" stroke-width="1" x="224.5" y="91.5" width="23" height="12"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill-opacity="0.03" fill="#343A3E" fill-rule="evenodd" xlink:href="#path-16"></use>
                  <rect stroke-opacity="0.711050725" stroke="#DEE2E5" stroke-width="1" x="224.5" y="51.5" width="23" height="13"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill-opacity="0.03" fill="#343A3E" fill-rule="evenodd" xlink:href="#path-17"></use>
                  <rect stroke-opacity="0.711050725" stroke="#DEE2E5" stroke-width="1" x="224.5" y="66.5" width="23" height="13"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-18"></use>
                  <rect stroke="#DEE2E5" stroke-width="1" x="94.5" y="58.5" width="8" height="1"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-19"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="132.5" y="21.5" width="14" height="3"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-20"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="148.5" y="21.5" width="10" height="3"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-21"></use>
                  <rect stroke-opacity="0.204483696" stroke="#66A7FF" stroke-width="1" x="122.5" y="27.5" width="25" height="6"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-22"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="122.5" y="35.5" width="25" height="6"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-23"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="122.5" y="43.5" width="25" height="6"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-24"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="149.5" y="27.5" width="25" height="6"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-25"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="149.5" y="35.5" width="25" height="6"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-26"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="149.5" y="43.5" width="25" height="6"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-27"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="176.5" y="27.5" width="25" height="6"></rect>
                </g>
                <g id="Rectangle-14">
                  <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-28"></use>
                  <rect stroke="#F1F3F4" stroke-width="1" x="176.5" y="35.5" width="25" height="6"></rect>
                </g>
                <rect id="Rectangle-5" fill="#ACB4BB" x="78" y="6" width="173" height="6"></rect>
                <polyline id="Path-7" stroke="#66A7FF" stroke-width="0.5" opacity="0.800000012" points="100 71.0641026 107.642424 74.2692308 116.460606 77.5512821 127.630303 76.0769231 132.333333 80.5 145.854545 69 158.5 72 171 89.5 177.5 78 184.654545 72.9807692 197 69.8846154"></polyline>
                <polyline id="Path-9" stroke="#AA76F1" stroke-width="0.5" opacity="0.800000012" points="100 90.2272727 107.054545 90.2272727 133.509091 84.6136364 144.678788 92 158.787879 83.1363636 171.133333 92 176.424242 88.4545455 184.654545 87.2727273 197 79"></polyline>
              </g>
            </g>
            <g id="Oval">
              <use fill="black" fill-opacity="1" filter="url(#filter-30)" xlink:href="#path-29"></use>
              <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-29"></use>
              <use fill-opacity="0.5" fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-29"></use>
            </g>
            <polyline id="Path-14" stroke="#66A7FF" stroke-width="5" points="678 275.883398 686.839799 284.504688 707.54354 264"></polyline>
          </g>
        </g>
      </svg>
      <h1>Welcome to your Awair Dashboard</h1>
      <p>
        Access the tools you need to effectively manage your organization's indoor health.
      </p>
      <button mat-button mat-dialog-close>Get Started</button>
    </div>
  `,
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
